import {AVATAR_ANIMATION} from "utils/constants";
import produce from "immer";

const initialState = {
  action: {
    command: "",
    name: "",
  },
};

const animationBar = (state = initialState, action) => {
  const {type, payload} = action;

  switch (payload) {
    case "ID_ACTION_ANIMATION_HI":
      return produce(state, draft => {
        draft.action = {
          command: type,
          name: AVATAR_ANIMATION.HI,
        };
      });
    case "ID_ACTION_ANIMATION_GOOD":
      return produce(state, draft => {
        draft.action = {
          command: type,
          name: AVATAR_ANIMATION.THUMBS_UP,
        };
      });
    case "ID_ACTION_ANIMATION_DANCE":
      return produce(state, draft => {
        draft.action = {
          command: type,
          name: AVATAR_ANIMATION.WOO,
        };
      });
    case "ID_ACTION_ANIMATION_PICK":
      return produce(state, draft => {
        draft.action = {
          command: type,
          name: AVATAR_ANIMATION.PICK,
        };
      });
    case "ID_ACTION_ANIMATION_SIT":
      return produce(state, draft => {
        draft.action = {
          command: type,
          name: AVATAR_ANIMATION.GROUND_SIT,
        };
      });
    case "ID_ACTION_ANIMATION_SCARE":
      return produce(state, draft => {
        draft.action = {
          command: type,
          name: AVATAR_ANIMATION.HALLOWEEN_SCARE,
        };
      });
    default:
      return state;
  }
};

export default animationBar;
